/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the "Elastic License
 * 2.0", the "GNU Affero General Public License v3.0 only", and the "Server Side
 * Public License v 1"; you may not use this file except in compliance with, at
 * your election, the "Elastic License 2.0", the "GNU Affero General Public
 * License v3.0 only", or the "Server Side Public License, v 1".
 */

export let ESQLVariableType = /*#__PURE__*/function (ESQLVariableType) {
  ESQLVariableType["TIME_LITERAL"] = "time_literal";
  ESQLVariableType["FIELDS"] = "fields";
  ESQLVariableType["VALUES"] = "values";
  ESQLVariableType["FUNCTIONS"] = "functions";
  return ESQLVariableType;
}({});
export const apiPublishesESQLVariable = unknownApi => {
  return Boolean(unknownApi && (unknownApi === null || unknownApi === void 0 ? void 0 : unknownApi.esqlVariable$) !== undefined);
};
export const apiPublishesESQLVariables = unknownApi => {
  return Boolean(unknownApi && (unknownApi === null || unknownApi === void 0 ? void 0 : unknownApi.esqlVariables$) !== undefined);
};